import { Path } from "enums";
import AddAccountTypeModule from "modules/customer/account-types/account-type-add/account-type-add.module";
import EditAccountTypeModule from "modules/customer/account-types/account-type-edit/account-type-edit.module";
import ViewAccountTypeModule from "modules/customer/account-types/account-type-view/account-type-view.module";
import AccountTypesListModule from "modules/customer/account-types/account-types-list/account-types-list.module";
import AccountTypesVipListModule from "modules/customer/account-types/account-types-vip-list/account-types-vip-list.module";
import AddAccountTypeVipModule from "modules/customer/account-types/account-type-vip-add/account-type-vip-add.module";
import EditAccountTypeVipModule from "modules/customer/account-types/account-type-vip-edit/account-type-vip-edit.module";
import ViewAccountTypeVipModule from "modules/customer/account-types/account-type-vip-view/account-type-vip-view.module";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

const AccountTypesPage = () => {
  return (
    <Switch>
      <Route exact path={Path.AccountTypesOld} component={AccountTypesListModule} />
      <Route exact path={Path.AccountTypes} component={AccountTypesVipListModule} />
      <Route exact path={Path.AddAccountTypeOld} component={AddAccountTypeModule} />
      <Route exact path={Path.AddAccountType} component={AddAccountTypeVipModule} />
      <Route exact path={Path.ViewAccountTypeOld} component={ViewAccountTypeModule} />
      <Route exact path={Path.ViewAccountType} component={ViewAccountTypeVipModule} />
      <Route exact path={Path.EditAccountTypeOld} component={EditAccountTypeModule} />
      <Route exact path={Path.EditAccountType} component={EditAccountTypeVipModule} />
      <Redirect to={Path.AccountTypes} />
    </Switch>
  );
};

export default AccountTypesPage;
